let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fopkd")).then(() => parcelRequire('7QYfj'));